import styled from 'styled-components';
import { CtaButton } from '../common-components/CtaButton';
import { HtmlZone } from '../common-components/HtmlZone';

export const HomeCtaButton = styled(CtaButton)`
  height: 10vh;
  padding: 1vh 1vw;
  position: absolute;
  bottom: 8vh;
  left: 10vw;
  right: 10vw;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 5vw;
`;
HomeCtaButton.displayName = 'HomeCtaButton';

export const HomeAcceptHtmlZone = styled(HtmlZone)`
  top: auto;
  bottom: 2vh;
  right: 8vw;
  left: 8vw;
`;
HomeAcceptHtmlZone.displayName = 'HomeAcceptHtmlZone';
